import type {ToolUserRequestedMessage} from '../../types/session'
import {isExitPlanModeArguments} from '../../types/session'
import {ResolvedPlanApproval} from './ResolvedPlanApproval'

interface PlanApprovalLogEntryProps {
  prompt: ToolUserRequestedMessage
  resolvedAnswer?: string
  isAborted?: boolean
}

/** Renders a resolved exit_plan_mode prompt in the session logs timeline. */
export function PlanApprovalLogEntry({prompt, resolvedAnswer, isAborted = false}: PlanApprovalLogEntryProps) {
  if (!isExitPlanModeArguments(prompt.arguments)) {
    return null
  }

  const {summary, planContent, resolution} = prompt.arguments

  if (!resolution && !resolvedAnswer && !isAborted) {
    return null
  }

  return (
    <ResolvedPlanApproval
      resolution={resolution}
      resolvedAnswer={resolvedAnswer}
      isAborted={isAborted}
      summary={planContent || summary}
    />
  )
}
